<!-- 有修正要檢查同步改到 jkaggrid.component.html -->

<div class="flex">
  <div class="flex">
    <div>
      <label>{{itemList.length}} 筆</label>
    </div>
    <button class="btn" matSuffix mat-icon-button (click)="onFirstRow()" matTooltip="第一筆">
      <mat-icon>first_page</mat-icon>
    </button>
    <button class="btn" matSuffix mat-icon-button (click)="onPreviousRow()" matTooltip="上一筆">
      <mat-icon>navigate_before</mat-icon>
    </button>
    <button class="jk-button-small" matSuffix mat-icon-button aria-label="open win" [matTooltip]="openwinItemStr()"
      (click)="doShowInfo($event)">
      <mat-icon>more_vert</mat-icon>
    </button>
    <button class="btn" matSuffix mat-icon-button (click)="onNextRow()" matTooltip="下一筆">
      <mat-icon>navigate_next</mat-icon>
    </button>
    <button class="btn" matSuffix mat-icon-button (click)="onLastRow()" matTooltip="最後一筆">
      <mat-icon>last_page</mat-icon>
    </button>
    <button class="btn" matSuffix mat-icon-button (click)="onSumAll()" matTooltip="總計">
      <mat-icon>summarize</mat-icon>
    </button>
  </div>
  <div class="flex">
    <app-jkedit [width]="40" placeholder="快搜" [showClearButton]="false" [(value)]="gridSearchValue">
    </app-jkedit>
    <button class="btn" [class.btn-secondary]="true" (click)="searchGrid(gridSearchValue)">
      <mat-icon fontIcon="search" slot="start" name="search-circle-outline"></mat-icon>
    </button>
    <app-jkedit [width]="40" placeholder="快篩,其中包含..." [showClearButton]="false" [(value)]="gridFilterValue"
      (valueChange)="onFilterTextBoxChanged($event)">
    </app-jkedit>
  </div>
</div>

<div class="w-full" [cdkContextMenuTriggerFor]="context_menu">

  <ag-grid-angular #myGrid [theme]="gridSrv.theme" [ngStyle]="gridStyle" [columnDefs]="columnDefs"
    [columnTypes]="gridSrv.columnTypes" [defaultColDef]="gridSrv.defaultColDef" [localeText]="gridSrv.localeText"
    [pagination]="gridSrv.pagination" [paginationPageSize]="gridSrv.paginationPageSize"
    [paginationPageSizeSelector]="gridSrv.paginationPageSizeSelector" [rowSelection]="gridSrv.rowSelection"
    [rowData]="itemList" (gridReady)="onGridReady($event)" (keydown)="onKeydown($event)"
    (rowClicked)="onRowClicked($event)" (rowDoubleClicked)="onRowDoubleClicked($event)" [enableBrowserTooltips]="true"
    (cellValueChanged)="onCellValueChanged($event)" (rowSelected)="onRowSelected($event)"
    (selectionChanged)="onSelectionChanged()" [editType]="'fullRow'" (rowEditingStarted)="onRowEditingStarted($event)"
    (rowEditingStopped)="onRowEditingStopped($event)">
  </ag-grid-angular>
</div>

<ng-template #context_menu>
  <div class="jk-menu" cdkMenu>
    @if(isJkaggrid){
    <button class="jk-menu-item" cdkMenuItem (click)="doUIEdit()">修改</button>
    <button class="jk-menu-item" cdkMenuItem (click)="doUIInsert()">新增</button>
    <button class="jk-menu-item" cdkMenuItem (click)="doUIDelete()">刪除</button>
    <button class="jk-menu-item" cdkMenuItem (click)="doSetup()">管理員設定</button>

    }
    <button class="jk-menu-item" cdkMenuItem (click)="doFilter('')">過濾條件</button>
    <button class="jk-menu-item" cdkMenuItem (click)="reloadGrid()">重新整理</button>
    <button class="jk-menu-item" cdkMenuItem>取消功能表</button>
    <button class="jk-menu-item" cdkMenuItem (click)="doItemList()">資料內容(json)</button>
    <button class="jk-menu-item" cdkMenuItem (click)="doMyExportExcel(itemList)">匯出Excel(xlsx)</button>
    <button class="jk-menu-item" cdkMenuItem (click)="gridSrv.doSaveTitle(columnDefs)">存欄位設定</button>
    <button class="jk-menu-item" cdkMenuItem (click)="gridSrv.doResetTitle()">重置欄位設定</button>
    <button class="jk-menu-item" cdkMenuItem (click)="gridSrv.doShowManagerField(columnDefs)">顯示管理欄位</button>
  </div>
</ng-template>
